/**
 * Scroll to top of page after filtering products
 *
 * @since   1.0.0
 * @package premier
 */

(function($) {
    $(document).ready(function() {

        var $wooFilterButtonActionFilter = $('.wcpf-button-action-filter');
        // check if the 'products filter for woocommerce plugin'
        // button to submit the filter exists, if not return
        if ($wooFilterButtonActionFilter.length < 1) {
            return;
        }

        var scrollAfterFilterAjaxModule = (function() {

            var init = function() {
                // wcpf_after_ajax_filtering is the plugin custom event
                // triggered after the filtering ajax is complete
                $(window).on('wcpf_after_ajax_filtering', function() {
					// scroll to top
					TweenMax.to(window, 0.5, {
                        scrollTo: {
                            y: 0,
                            autoKill: false
                        },
                        ease: Circ.easeOut
                    });
                });
            };

            return {
                init: init
            };
        })();

        scrollAfterFilterAjaxModule.init();

    }); // document.ready
})(jQuery);
